// Publishes the real height of the fixed top chrome as --chrome-height, so that
// content can reserve the band instead of guessing at it.
//
// This cannot be done in CSS. .site-header declares no height, and its desktop
// nav is a shrinkable flex row with no white-space:nowrap, so a longer NL or FR
// label can wrap to a second line near the 1024px breakpoint and make the header
// taller than any calc() could predict. _tokens.scss carries a flat, generous
// placeholder for the frames before this runs and for JS-less browsers.
export function initChrome() {
    const chrome = document.querySelector('.site-chrome')
    if (!chrome) return

    const root = document.documentElement
    const publish = () => {
        // offsetHeight, not contentRect: the header's padding is most of its
        // height, and the band content must clear is the border box.
        root.style.setProperty('--chrome-height', `${chrome.offsetHeight}px`)
    }

    publish()

    if ('ResizeObserver' in window) {
        new ResizeObserver(publish).observe(chrome)
    } else {
        window.addEventListener('resize', publish)
    }
}
